import myProfileActionsCreators from './my-profile';
import myProfileAddressesActionsCreators from './my-profile-addresses';
import myProfilePhonesActionsCreators from './my-profile-phones';

const myProfileActionCreators = {
  ...myProfileAddressesActionsCreators,
  ...myProfilePhonesActionsCreators,
  ...myProfileActionsCreators,
};

export default myProfileActionCreators;
